import styled from 'styled-components';
import { Flag as BaseFlag } from '../../../../components/Flag';
import DebitIcon from '../../../../assets/icon_debit.svg';
import CreditIcon from '../../../../assets/icon_credit.svg';

export const Flag = styled(BaseFlag)`
  & svg {
    width: 15px;
    border: 1px solid #9dc5e9;
  }

  & .country-name {
    margin-left: 3px;
  }
`;

export const EllipsisLabel = styled.div`
  text-overflow: ellipsis;
`;

export const BlueLabel = styled.div`
  color: #0c8ed7;
`;

export const FlexWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Debit = styled.div`
  width: 9px;
  height: 9px;
  background: url(${DebitIcon}) no-repeat;
  transform: rotate(180deg);
  margin-right: 8px;
`;

export const Credit = styled.div`
  width: 9px;
  height: 9px;
  background: url(${CreditIcon}) no-repeat;
  margin-right: 8px;
`;

export const RiskLevelBadge = styled.div`
  color: white;
  background: #df6057;
  padding: 0 8px;
  line-height: 18px;
  border-radius: 33px;
  margin-left: 8px;
  white-space: nowrap;
`;

export const BeneficiaryMoreDetailsLink = styled.a`
  color: #0c8ed7;
  margin-left: 24px;
`;

// FIN-11542 closing sweep: Beneficiary Details cell. Stack the summary line
// above the "More Details" link so a long beneficiary string no longer wraps
// mid-flex and splits the link onto its own broken line. The link sits on its
// own line, left-aligned, no left margin.
export const BeneficiaryCell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
`;

export const BeneficiarySummaryText = styled.div`
  line-height: 1.3;
`;

export const BeneficiaryDetailsLink = styled.a`
  color: #0c8ed7;
`;
